import ComponentManager from '@/Management/ComponentManager';
import ControlFactory from '@/Factories/ControlFactory';
import MultilineTextBoxViewModelType from '@/ViewModels/Controls/MultilineTextBoxViewModel';
import MultilineTextBoxType from '@/Controls/MultilineTextBox';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';
import Utilities from '@/Utility/Utilities';

export default class MultilineTextBoxFactory extends ControlFactory {

    private MultilineTextBoxViewModel = ComponentManager.getViewModel<typeof MultilineTextBoxViewModelType>('MultilineTextBoxViewModel');
    private MultilineTextBox = ComponentManager.getControl<typeof MultilineTextBoxType>('MultiLineTextBox');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');

    /**
    * Das JQuery-Element des Controls
    */
    private jqueryControl: JQuery

    /**
    * Gibt die Größe der Textbox an
    */
    public height: KnockoutObservable<number>;

    /**
     * Gibt an ob die PopUp-funtkion aktiviert ist.
     */
    public enablePopUp: boolean;

    /**
     * @override
     */
    public viewModel: MultilineTextBoxViewModelType;

    public constructor(params: any) {
        super(params);

        this.height = this.observableOrDefault(params.height);
        this.enablePopUp = this.paramOrDefault(params.enablePopUp, true);
    }

    /**
     * @override
     */
    control: MultilineTextBoxType;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jqueryControl != null) {
            return this.jqueryControl;
        }

        this.viewModel = this.createViewModel();
        this.control = this.createControl();

        let tuple = this.control.getTuple();
        this.jqueryControl = tuple.control;

        this.addOverwritableToControl(this.jqueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);
        this.registerCustomValidation([this.detailViewItem.name], this.viewModel.value, (value: string): boolean => {
            return Utilities.validateInputForInvalidCharacters(value);
        });

        return this.jqueryControl;
    }

    protected createViewModel() {
        let length = this.detailViewItem.length;
        if (isNaN(length) || length === 0) {
            if (this.detailViewItem.dotNetTypeName == null || this.detailViewItem.dotNetTypeName.indexOf('Double') === -1) {
                length = 255;
            }
            else {
                length = 326;
            }
        }

        return new this.MultilineTextBoxViewModel({
            factory: this,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            height: this.height,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isFocusable: this.isFocusable,
            isValid: this.isValid,
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            invalidationText: this.invalidationText,
            value: this.context.genericObject.getObservable(this.detailViewItem.name),
            maxLength: length,
            enablePopUp: this.enablePopUp,
            name: this.detailViewItem.name,
            ergName: this.detailViewItem.ergName,
        });
    }

    protected createControl() {
        return new this.MultilineTextBox(this.viewModel);
    }

    /**
     * @override
     */
    public getValueForFilter(): Object {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);
        return ret;
    }

    /**
     * @override
     */
    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: this.viewModel?.value() || ''
        }
    }
}

ComponentManager.setFactory('MultilineTextBox', MultilineTextBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');